import { render } from "./TraceDashboard.vue?vue&type=template&id=1d97f7e7"
import script from "./TraceDashboard.vue?vue&type=script&lang=js"
export * from "./TraceDashboard.vue?vue&type=script&lang=js"

import "./TraceDashboard.vue?vue&type=style&index=0&id=1d97f7e7&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__